import { inject } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

import type { IconResolverFn } from './provide-icons';
import { ICON_RESOLVER_BASE_HREF } from './provide-icons';

export const iconResolver: IconResolverFn = () => {
  const domSanitizer = inject(DomSanitizer);
  const baseHref = inject(ICON_RESOLVER_BASE_HREF);
  return (name, namespace) => {
    const url = `${baseHref}icons/${namespace}/${name}.svg`;
    return domSanitizer.bypassSecurityTrustResourceUrl(url);
  };
};
